import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/System/Update/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemPerm';
import UpdateTable from 'components/Web_User_Interface/1440p_Series/System/Update/updateTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "System Menü // Software Update",
  "path": "/Web_User_Interface/1440p_Serie/System/Update/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Die INSTAR Software Abteilung arbeitet konstant daran die Erfahrung mit unseren Produkten zu verbessern. Überprüfen Sie hier ob die Software Ihrer Kamera noch aktuell ist. Alternativ können Sie auch unseren Download Bereich besuchen, um die neueste Software und deren Changelog zu finden.",
  "image": "./WebUI_1440p_SearchThumb_System_Update.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_System_Update.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='System Menü // Software Update' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Die INSTAR Software Abteilung arbeitet konstant daran die Erfahrung mit unseren Produkten zu verbessern. Überprüfen Sie hier ob die Software Ihrer Kamera noch aktuell ist. Alternativ können Sie auch unseren Download Bereich besuchen, um die neueste Software und deren Changelog zu finden.' image='/images/Search/WebUI_1440p_SearchThumb_System_Update.png' twitter='/images/Search/WebUI_1440p_SearchThumb_System_Update.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/System/Update/' locationFR='/fr/Web_User_Interface/1440p_Series/System/Update/' crumbLabel="Software Update" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "system-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#system-men%C3%BC",
        "aria-label": "system menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`System Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "halten-sie-ihre-kamera-auf-dem-neusten-stand",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#halten-sie-ihre-kamera-auf-dem-neusten-stand",
        "aria-label": "halten sie ihre kamera auf dem neusten stand permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Halten Sie Ihre Kamera auf dem neusten Stand`}</h3>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/9fc37a9532a815c54c5a5a92bbd2a13a/e4a12/1440p_Settings_System_Update.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "53.91304347826087%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7rAAAO6wFxzYGVAAAClElEQVQoz2WQXWscVRyH9zMo3tak1CQzszsbV73ZZLOuedndeTtz5sxbdiZpNt26EZbayPRlIxVqq1CkFBRJLgLipY0iVBC8EL3z0pfPIL3wSzyyk4IBLx7O+f85PPx+p2KadXRNozv5Eu/eM+y7ZzhH37F56ykbxTf/Y7bfun3GevGU3p0z9h7/wsa7j3nl5ZeYn5+nUq1W0ZaW8A8esj09Jbl1THL7mLCYcfKC8zkqTvBufI47eUJw+AVRcUx+dIo8eIChGdTrDSqGYaBpGv3NDoHbw7e7KGGhvD7S6eLbW+VZ3p0uk/E+70/eIxsMkPZGuXP6W7zd3qS12vlPaNk2KoyQgSLf2UX4kvX1DQZZjpQBYRiRpANG1w94/vwfjn/7m73pQwLPLd+utTqsNNcuJOz3ieOY/f19ms0mjUYDy7LY2dlBSokQgul0yqePnhCHMd/+/DufnT7DtXsI4dNuvcNKs30hoWURRVEpmImvj0bsZhnCc1FBgOO4FEXBX3/+wb37j/j+x1+5+cEhjuvieaJM2Fq9ILQtiySJCcOQQZoQD0dsHz0gm36MGuREYVim9IRguHuVqQr4SEn2ogjbddnstGmvtajoun5e2bKJ0pwwyfClRM7+bDgi2btGEIakaUqeZ0RKIpw+wyTmWpYhlcLzvFK4urJGZSbTNB3p9jkcBty46rMdB/i+jxTeOVKWtVWUovIxfj4mVSkjTzASPtJ16bRfVNZ1jQWtyjjt89Mngh/uu0x2fYQMCUOFUjNClBQE2Yj07inqw68p0jFf9WxOHInq9rh85TUWFxbOE85qL7/ewFh+C73+JsuNN6ibJrWaiWleoFalpi9i6gsYtSqLdZOleh3NMHj10iXm5ub4FwxYsyZtLaelAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/9fc37a9532a815c54c5a5a92bbd2a13a/e4706/1440p_Settings_System_Update.avif 230w", "/de/static/9fc37a9532a815c54c5a5a92bbd2a13a/d1af7/1440p_Settings_System_Update.avif 460w", "/de/static/9fc37a9532a815c54c5a5a92bbd2a13a/7f308/1440p_Settings_System_Update.avif 920w", "/de/static/9fc37a9532a815c54c5a5a92bbd2a13a/43a10/1440p_Settings_System_Update.avif 963w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/9fc37a9532a815c54c5a5a92bbd2a13a/a0b58/1440p_Settings_System_Update.webp 230w", "/de/static/9fc37a9532a815c54c5a5a92bbd2a13a/bc10c/1440p_Settings_System_Update.webp 460w", "/de/static/9fc37a9532a815c54c5a5a92bbd2a13a/966d8/1440p_Settings_System_Update.webp 920w", "/de/static/9fc37a9532a815c54c5a5a92bbd2a13a/095e2/1440p_Settings_System_Update.webp 963w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/9fc37a9532a815c54c5a5a92bbd2a13a/81c8e/1440p_Settings_System_Update.png 230w", "/de/static/9fc37a9532a815c54c5a5a92bbd2a13a/08a84/1440p_Settings_System_Update.png 460w", "/de/static/9fc37a9532a815c54c5a5a92bbd2a13a/c0255/1440p_Settings_System_Update.png 920w", "/de/static/9fc37a9532a815c54c5a5a92bbd2a13a/e4a12/1440p_Settings_System_Update.png 963w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/9fc37a9532a815c54c5a5a92bbd2a13a/c0255/1440p_Settings_System_Update.png",
              "alt": "Web User Interface - 1440p Series - System Update",
              "title": "Web User Interface - 1440p Series - System Update",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Laden Sie sich bitte die neueste Firmware für Ihre INSTAR HD Kamera auf der linken Seite herunter und entpacken Sie die heruntergeladenen ZIP Datei. Sie finden darin dann eine "update.pkg" Datei. Öffnen Sie die Weboberfläche Ihrer Kamera und gehen Sie dort auf "Software - Upgrade" und wählen Sie dort die "update.pkg" Datei aus, um diese auf Ihre Kamera aufzuspielen. Bestätigen Sie das Ganze und warten Sie bis zu 12 Minuten bis das Update komplett aufgespielt wurde.`}</p>
    <EuiSpacer mdxType="EuiSpacer" />
    <UpdateTable mdxType="UpdateTable" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "firewall",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#firewall",
        "aria-label": "firewall permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Firewall`}</h3>
    <p>{`Damit der automatische Aktualisierungsdienst funktioniert, müssen Sie Ihrer Kamera erlauben, die INSTAR Update-Server zu kontaktieren:`}</p>
    <blockquote>
      <p parentName="blockquote"><a parentName="p" {...{
          "href": "/de/Frequently_Asked_Question/WQHD_Auto-Update_Servers/"
        }}>{`Ich kann meine Kamera nicht über die Web-Benutzeroberfläche aktualisieren, weil unsere Firewall den Internetzugang einschränkt. Welche URLs und Ports muss ich für die Kamera öffnen, um Online-Updates durchzuführen?`}</a></p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      